import { render, staticRenderFns } from "./AtomMenuItem.vue?vue&type=template&id=0ea1e677&scoped=true&"
import script from "./AtomMenuItem.vue?vue&type=script&lang=js&"
export * from "./AtomMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./AtomMenuItem.vue?vue&type=style&index=0&id=0ea1e677&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1e677",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
